var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"finger",rawName:"v-finger:swipe",value:(_vm.swipe),expression:"swipe",arg:"swipe"}],staticClass:"swiper-wrapper",style:({
      width: _vm.containerWidth,
      height: _vm.containerHeight
    })},[_c('div',{staticClass:"swiper-inner",style:({
      width: _vm.sliderWidth || '100%'
    })},[_vm._t("default")],2),_vm._v(" "),(_vm.showNav)?_c('ul',{staticClass:"swiper-nav"},_vm._l((_vm.size),function(i){return _c('li',{key:i,class:{ selected: ((i-1) === _vm.currentIndex) }})})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560aff56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/swiper.vue
// module id = null
// module chunks = 